import React, { memo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { View, Text, TextInput, StyleSheet } from 'react-native';

import FormErrors from '../errors/FormErrors';

import { COLORS, FONTS } from '@bcm/constants';
import { INPUT_LENGTH } from '../../../../constants/UIConstants';

// eslint-disable-next-line react/display-name
const Input = React.forwardRef((props, ref) => {
	const [selectedValue, setSelectedValue] = useState(props.defaultValue);
	const styles = StyleSheet.create({
		label: {
			fontFamily: FONTS.bold,
			color: COLORS.textDark,
			margin: 5,
			marginLeft: 0,
		},
		input: {
			textAlignVertical: (props.numberOfLines && props.numberOfLines > 1) ? 'top' : undefined,
			backgroundColor: COLORS.white,
			borderColor: props.errors ? COLORS.textError : COLORS.clear,
			borderWidth: props.errors ? 2 : 0,
			minHeight: 40,
			padding: 5,
			borderRadius: 5,
		},
	});

	return (
		<View style={props.style}>
			<Text numberOfLines={1} style={styles.label}>{props.label}</Text>
			<Controller
				control={props.control}
				render={({field: { onChange, onBlur }}) => (
					<TextInput
						ref={(ref) ? ref : null}
						style={styles.input}
						onBlur={(props.onBlur) ? props.onBlur : onBlur}
						onChangeText={(item) => {
							setSelectedValue(item);
							onChange(item);
						}}
						value={selectedValue}
						autoCorrect={(props.autoCorrect === true || props.autoCorrect === false) ? props.autoCorrect : true}
						autoCapitalize={(props.autoCapitalize) ? props.autoCapitalize : 'sentences'}
						secureTextEntry={(props.secureTextEntry) ? props.secureTextEntry : false}
						multiline={(props.multiline) ? props.multiline : false }
						numberOfLines={(props.numberOfLines) ? props.numberOfLines : undefined }
						testID={`${props.name}Input`}
						onKeyPress={(props.onKeyPress) ? props.onKeyPress : null}
						inputMode={props.inputMode}
						maxLength={(props.rules && props.rules.maxLength) ? props.rules.maxLength + 1 : INPUT_LENGTH.MAX_INPUT + 1}
					/>
				)}
				name={props.name}
				testID={`${props.name}Controller`}
				defaultValue={props.defaultValue}
				rules={props.rules}
			/>
			<FormErrors
				key={`${props.name}FormErrorsKey`}
				errors={props.errors}
				errorTexts={props.errorTexts}
			/>
		</View>
	);
});

export default memo(Input);